var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M250 0L309.017 181.636H500L345.491 293.893L404.508 475.528L250 363.271L95.4915 475.528L154.508 293.893L0 181.636H190.983L250 0Z"}));
}

Star.defaultProps = {"width":"500","height":"476","fill":"none","aria-label":"star","viewBox":"0 0 500 476"};

module.exports = Star;

Star.default = Star;
